import { jwtDecode } from "jwt-decode";

type TokenPayload = {
  avatar: string;
  city: string;
  country: string;
  email: string;
  exp: number;
  expireTime: string;
  fullName: string;
  hometown: string;
  telephoneNumber: string;
  userId: string;
  userName: string;
  userRole: 'ADMIN' | 'USER' | string;
}

export function DecodeToken(token: string | null | undefined) {
  if (token == null) {
    return null;
  }
  try {
    let tokenPayload: TokenPayload = jwtDecode(token);
    if (tokenPayload) {
      return tokenPayload;
    }
  } catch (error) {
    return null;
  }
}
